import { Helmet } from "react-helmet-async";
import { COMPANY } from "@/config/company";

interface ArticleJsonLdProps {
  title: string;
  description: string;
  author: string;
  publishedAt: string;
  updatedAt?: string;
  imageUrl?: string;
  url: string;
  keywords?: string[];
}

export function ArticleJsonLd({
  title,
  description,
  author,
  publishedAt,
  updatedAt,
  imageUrl,
  url,
  keywords = [],
}: ArticleJsonLdProps) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    description: description,
    author: {
      "@type": "Organization",
      name: author || "TrustedHeal",
      url: COMPANY.website,
    },
    publisher: {
      "@type": "Organization",
      name: "TrustedHeal",
      logo: {
        "@type": "ImageObject",
        url: `${COMPANY.website}/logos/logo-icon-teal.svg`,
      },
    },
    datePublished: publishedAt,
    dateModified: updatedAt || publishedAt,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": url,
    },
    ...(imageUrl && {
      image: {
        "@type": "ImageObject",
        url: imageUrl,
      },
    }),
    ...(keywords.length > 0 && {
      keywords: keywords.join(", "),
    }),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
